var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 8,
    fill: "#222260"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 94,
    height: 94,
    rx: 5,
    stroke: "#DD5C5C",
    strokeOpacity: 0.72,
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5881 20.5884V79.4119H79.4117V20.5884H20.5881ZM52.5997 66.4655C52.5997 72.1903 49.2383 74.8032 44.3408 74.8032C39.9159 74.8032 37.3555 72.5185 36.0424 69.748L40.5461 67.0301C41.4127 68.5663 42.2005 69.8662 44.1044 69.8662C45.9164 69.8662 47.0718 69.1572 47.0718 66.3867V47.5973H52.5997V66.4655V66.4655ZM65.6774 74.8032C60.5435 74.8032 57.2215 72.361 55.6065 69.1572L60.1102 66.5574C61.2919 68.4875 62.8413 69.9187 65.5592 69.9187C67.8439 69.9187 69.3145 68.7764 69.3145 67.1876C69.3145 65.2969 67.8176 64.6272 65.2835 63.5112L63.9048 62.9203C59.9132 61.2265 57.2741 59.0863 57.2741 54.5826C57.2741 50.4334 60.4384 47.2822 65.3623 47.2822C68.8812 47.2822 71.4022 48.5033 73.2142 51.7071L68.9075 54.4644C67.9621 52.7706 66.9379 52.101 65.3492 52.101C63.7341 52.101 62.71 53.1251 62.71 54.4644C62.71 56.1188 63.7341 56.7885 66.1107 57.8258L67.4894 58.4166C72.19 60.4256 74.8292 62.487 74.8292 67.1089C74.8292 72.0721 70.9164 74.8032 65.6774 74.8032V74.8032Z",
    fill: "#F2AE00",
    fillOpacity: 0.88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ed44388cc09b43b75dd3e9920a43eabf.svg";
export { ForwardRef as ReactComponent };